import { useFirestoreNoCompagnyGeneralOrderBy } from '../../firebase/useFirestore'
import latestActivity from '../../helpers/dataHelpers/latestActivity'

/**
 * Rapportagekolom op het projectenoverzicht: hoeveel rapportages heeft dit
 * project, en wanneer is de laatste gemaakt.
 *
 * 'Laatste' komt uit `latestActivity`, dat op de grootste tijdstempel kiest en
 * niet op een positie in de lijst — deze kolom pakte `reports.length - 1` uit
 * een AFLOPEND gesorteerde lijst en toonde daarmee de OUDSTE rapportage. Dat
 * raakte ook de kleur: `daysAgo` kwam uit datzelfde oude item, dus een project
 * kleurde voor altijd rood zodra het ooit iets ouds bevatte.
 *
 * @param {object} props
 * @param {string} props.projectId - `CompagnyID` van het project waarvan de rapportages geteld worden
 */
const ProjectReportsProgress = ({projectId}) => {
  // Firestore
  const reports = useFirestoreNoCompagnyGeneralOrderBy('LiveReports', 'CompagnyID', projectId ? projectId : '', 'Timestamp', 'desc')

  // 'Nog niet geladen' is een eigen toestand: de leesengine geeft '' tot de
  // eerste snapshot binnen is, en 'nul rapportages' is dan een bewering aan de
  // lezer die niet waar hoeft te zijn.
  // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
  const loaded = Array.isArray(reports)

  // Last result
  const last = latestActivity(reports)

    return (
    <div>
        <p className={`project-progress ${!loaded ? 'project-progress--unknown' : reports.length === 0 ? 'project-progress--alert' : 'project-progress--ok'}`}>
          Aantal: {loaded ? reports.length : '–'}
        </p>
        {!loaded
          ? <p className="project-progress project-progress--unknown">Laatste: –</p>
          : last.atMs === null
            ? '-'
            : <p className={`project-progress ${last.daysAgo > 30 ? 'project-progress--alert' : 'project-progress--ok'}`}>Laatste: {last.label}</p>}
    </div>
    )
}

export default ProjectReportsProgress
